import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { find, map } from 'lodash'
import PropTypes from 'prop-types'

import { PUBLIC_URL } from '../../common/constants'
import {
  CrackIcon,
  DentIcon,
  Dirt2Icon,
  MultipleDamageIcon,
  RepairFailedIcon,
  RepairSuccesIcon,
  Scratch2Icon,
  SingleDamageIcon,
} from '../../icons'

import DamagesList from './common/DamagesList'
import DamagesMesh from './common/DamagesMesh'

function BodyDamages({ digitalCertificate }) {
  const { bodyConditions } = digitalCertificate
  const { t } = useTranslation()

  const damageIcons = {
    Odprysk: <Scratch2Icon />,
    Pęknięcie: <CrackIcon />,
    'Po Naprawie': <RepairSuccesIcon />,
    Rysa: <Scratch2Icon />,
    'Rysa z uszkodzeniem lakieru': <Scratch2Icon />,
    Uszkodzenie: <SingleDamageIcon />,
    'Wgniecenie do 20mm': <DentIcon />,
    'Wgniecenie powyżej 20mm': <DentIcon />,
    Zabrudzenie: <Dirt2Icon />,
    'Zła jakość naprawy': <RepairFailedIcon />,
    'Ubytek lakieru': <Scratch2Icon />,
    'Wiele uszkodzeń': <MultipleDamageIcon />,
  }

  const elementsIconsCoords = [
    { bodyElementId: 1, coords: [65, 128] },
    { bodyElementId: 2, coords: [57, 30] },
    { bodyElementId: 3, coords: [307, 40] },
    { bodyElementId: 4, coords: [57, 227] },
    { bodyElementId: 5, coords: [307, 217] },
    { bodyElementId: 6, coords: [170, 35] },
    { bodyElementId: 7, coords: [225, 35] },
    { bodyElementId: 8, coords: [170, 220] },
    { bodyElementId: 9, coords: [225, 220] },
    { bodyElementId: 10, coords: [318, 128] },
    { bodyElementId: 11, coords: [205, 128] },
    { bodyElementId: 12, coords: [5, 128] },
    { bodyElementId: 13, coords: [346, 128] },
    { bodyElementId: 14, coords: [128, 128] },
    { bodyElementId: 15, coords: [280, 128] },
    { bodyElementId: 16, coords: [179, 69] },
    { bodyElementId: 17, coords: [230, 69] },
    { bodyElementId: 18, coords: [179, 188] },
    { bodyElementId: 19, coords: [230, 188] },
    { bodyElementId: 20, coords: [136, 53] },
    { bodyElementId: 21, coords: [136, 203] },
    { bodyElementId: 22, coords: [196, 51] },
    { bodyElementId: 23, coords: [196, 204] },
    { bodyElementId: 24, coords: [200, 8] },
    { bodyElementId: 25, coords: [200, 248] },
  ]
  const bodyConditionsWithCoords = map(bodyConditions, (elem) => {
    const item = find(elementsIconsCoords, {
      bodyElementId: elem.bodyElementId,
    })
    if (item) {
      const mainDamage = find(elem.bodyDamages, { isMain: true }) || false
      return {
        ...elem,
        coords: item.coords,
        mainDamage,
      }
    }
    return elem
  })

  return (
    <Grid container spacing={3}>
      <Grid item xs={5}>
        <Typography variant="h4">{t('bodyCondition.inspection')}</Typography>
        <DamagesList
          items={[
            {
              icon: <Scratch2Icon />,
              label: t('bodyDamages.scratch'),
            },
            { icon: <CrackIcon />, label: t('bodyDamages.crack') },
            {
              icon: <DentIcon />,
              label: t('bodyDamages.dent'),
            },
            { icon: <Dirt2Icon />, label: t('bodyDamages.dirt') },
            {
              icon: <RepairSuccesIcon />,
              label: t('bodyDamages.repairSuccess'),
            },
            {
              icon: <RepairFailedIcon />,
              label: t('bodyDamages.repairFailed'),
            },
            {
              icon: <SingleDamageIcon />,
              label: t('bodyDamages.singleDamage'),
            },
            {
              icon: <MultipleDamageIcon />,
              label: t('bodyDamages.multiDamage'),
            },
          ]}
        />
      </Grid>
      <Grid item xs={7}>
        <DamagesMesh
          conditions={bodyConditionsWithCoords}
          damageIcons={damageIcons}
          mesh={`${PUBLIC_URL}/assets/images/car_body_mesh.png`}
          prefix="body"
          width={280}
        />
      </Grid>
    </Grid>
  )
}

BodyDamages.propTypes = {
  digitalCertificate: PropTypes.object,
}
BodyDamages.defaultProps = {
  digitalCertificate: {},
}

export default BodyDamages
